<template>
  <div class="NavIndex">
    <div class="menu_all flex">
      <div
        class="drap_down flex"
        @mouseleave="outList"
        @mouseenter="showHidList = true"
      >
        <!-- <i class="nav_icon"></i> -->
        <SvgIcon
          color="#000000"
          size="20px"
          name="icon-chouti"
        ></SvgIcon>
        <span class="hidden-title">{{ TLang('京东优选分类','my') }}</span>
        <ul
          v-show="showHidList"
          class="hid-list"
        >
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i < 3"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 0 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="0"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 3 && i < 5"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 3 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="3"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 5 && i < 9"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 5 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="5"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 9 && i < 12"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 9 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="9"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 12 && i < 14"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 12 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="12"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 14 && i < 17"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 14 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="14"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 17 && i < 20"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 17 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="17"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 20 && i < 23"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 20 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="20"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 23 && i < 26"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 23 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="23"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
          <li
            class="drap_down-item"
          >
            <div
              v-for="(item,i) in catList"
              v-show="i >= 26 && i < 28"
              :key="`9+${i}+${item.id}`"
              :class="['text'+hash[i], i > 26 && 'long']"
            >
              <Category
                :id="item.id"
                :i="i"
                :x="26"
                :name="item.name"
                :onChange="onChange"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { unionFlag } from '@utils';
import Category from '../Category';
export default {
  name: 'NavIndex',
  components: {
    Category,
  },
  props: {
    catList: Array,
    onChange: Function,
  },
  data() {
    return {
      cateList: [],
      activeTitle: '',
      activeId: null,
      showHidList: false,
      activeItem: {},
      union: unionFlag(),
      hash: [4,2,2,4,2,2,2,2,2,2,4,2,2,4,4,2,4,4,2,2,4,2,4,4,2,4,4,3], // 写死的分类字数
    };
  },
  methods: {
    hoverItem(item) {
      this.cateList = [];
      if (item.name && item.id) {
        this.activeTitle = item.name;
        this.activeId = item.id;
        this.activeItem = item;
      }
    },
    outList() {
      // this.activeTitle = '';
      // this.activeId = null;
    },
  },
};
</script>

<style scoped lang="less">
.NavIndex {
  display: flex;
  background: #fff;
  height: 44px;
  .menu_all {
    width: 220px;
    background: #fafafa;
    border:1px solid #f0f0f0;
    background-size: 100% auto;
    font-size: 16px;
    color: #000000;
    text-align: center;
    line-height: 44px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .drap_down {
      position: relative;
      // width: 100%;
      // min-width: 200px;
      justify-content: left;
      box-sizing: border-box;
      .nav_icon{
        width: 16px;
        height: 14px;
        margin-right: 10px;
        background: url('./../LeftNavList/navIcon.png') center center no-repeat;
        background-size: 100% auto;
        margin-left: 52px;
      }
      .hidden-title{
        margin-left: 10px;
      }
      .hid-list {
        position: absolute;
        top: 100%;
        width: 100%;
        background: #fff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        z-index: 999;
        transition: all ease 800ms;
        display: none;
        li.drap_down-item {
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          display: flex;
          padding-left: 15px;
          padding-right: 10px;
          align-items: center;
          position: relative;
          white-space: nowrap;
          &::after {
            content: "";
            display: inline-block;
            height: 1px;
            width: 100%;
            background: #f7f7f7;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        li.drap_down-item:hover {
          cursor: pointer;
          background: var(--df-primary-color-opacity);
        }
      }
    }
    .drap_down:hover {
      cursor: pointer;
    }
    .drap_down:hover ul {
      display: block;
    }
  }
  ul.naviLink {
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    margin-left: 20px;
    li {
      margin-left: 15px;
      white-space: nowrap;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
